import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Panel, Btn, Th, Td, Field, Input, Textarea } from "@/admin/ui";

const PATHS = ["/", "/about", "/what-we-do", "/product-areas", "/our-brands", "/for-suppliers", "/for-buyers", "/quality-compliance", "/contact", "/insights"];

export default function SeoAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ path: "/", title: "", description: "", canonical: "", og_image: "" });
  const load = () => api.get("/api/admin/seo").then((r) => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = async () => {
    try { await api.put("/api/admin/seo", form); toast.success("SEO saved"); await load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const editRow = (r) => setForm({ path: r.path, title: r.title || "", description: r.description || "", canonical: r.canonical || "", og_image: r.og_image || "" });

  return (
    <div data-testid="admin-seo">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">SEO Metadata</h1>
      <div className="grid gap-4 lg:grid-cols-2">
        <Panel title="Edit metadata">
          <div className="space-y-4">
            <Field label="Path">
              <select className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" value={form.path} onChange={set("path")} data-testid="seo-path">
                {PATHS.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </Field>
            <Field label="Title"><Input value={form.title} onChange={set("title")} data-testid="seo-title" /></Field>
            <Field label="Description"><Textarea rows={3} value={form.description} onChange={set("description")} data-testid="seo-desc" /></Field>
            <Field label="Canonical URL"><Input value={form.canonical} onChange={set("canonical")} /></Field>
            <Field label="OG image URL"><Input value={form.og_image} onChange={set("og_image")} /></Field>
            <Btn onClick={save} data-testid="seo-save">Save</Btn>
          </div>
        </Panel>
        <Panel title="Configured paths">
          <table className="w-full">
            <thead className="border-b border-slate-100"><tr><Th>Path</Th><Th>Title</Th><Th></Th></tr></thead>
            <tbody className="divide-y divide-slate-50">
              {items.map((r) => (
                <tr key={r.path}><Td className="font-mono text-xs">{r.path}</Td><Td>{r.title}</Td><Td><Btn variant="ghost" onClick={() => editRow(r)}>Edit</Btn></Td></tr>
              ))}
              {items.length === 0 && <tr><Td className="text-ink-muted">Using default metadata.</Td></tr>}
            </tbody>
          </table>
        </Panel>
      </div>
    </div>
  );
}
